// config/apiConfig.js
import axios from "axios";
import { toast } from "react-toastify";
import { io }   from "socket.io-client";

/* ─── toggle once, use everywhere ─── */
const IS_LIVE = true;                                // ⬅️ flip when you deploy
const BASE_URL   = IS_LIVE
  ? "https://verjew-api.onrender.com"
  : "http://localhost:3001";

const SOCKET_URL = BASE_URL;                          // same host; change if needed

/* ─── Axios instance ─── */
const apiInstance = axios.create({ baseURL: BASE_URL });

apiInstance.interceptors.response.use(
  res => res,
  err => {
    if (err.response && [401, 403].includes(err.response.status)) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      toast.error("Session expired. Please log in again.");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

/* ─── single socket connection ─── */
const socket = io(SOCKET_URL, { autoConnect: true });

export { apiInstance, socket };
